export const environment = {
  production: true,
  apiUrl: 'https://rok5euhxgd.execute-api.us-east-1.amazonaws.com/prod',
  deployUrl: '',
  baseUrl: 'https://app.kinnect.us',
  recaptcha_siteKey: '6LfSP8opAAAAAEbtkhUq01OZkNFb_BIlxm9S01nG',
  cookieDomain: 'app.kinnect.us',
  region: 'us-east-1',
  userPoolId: 'us-east-1_jZkhjA75e',
  identityPoolId: 'us-east-1:27783849-1cb8-430b-89d3-50b22f290173',
  userPoolWebClientId: '5ai9sakj57qvkd20o32er44o8p',
  cognitoDomain: 'kinnect-prod.auth.us-east-1.amazoncognito.com',
  cognitoRedirectUrl: 'https://app.kinnect.us/oauth-return',
  JEST_EMAIL: 'dilip+jest@kinnect.us',
  JEST_PASSWORD: 'Jest@123',

  graphqlEndpoint: 'https://b7lnlrzdl5cuhf5fq4udj7k7o4.appsync-api.us-east-1.amazonaws.com/graphql',
  stripe_public_key: 'pk_live_51IuctCDMVpGY3JVKi4SMDZRlGkxkanl0lleLw4WuUxnCJQO7I1f7j7vVSaCgKQTK4Fu2rsZTg47pzDvyuZi6ukzl00PG1k5zIE',

  encryption_mask_id: '15f04d08097b49b7',
  show_professional_checkbox: false,
  crypto_public_key:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAw7eRbHjdIeRZaLD1x1sa4nvqfJwum2zVYC7ov7zynWdg4i1saPi+NDXgD5g9eyXnC14buKFs93ALaueXnqV2wFnbbWUZLXd+n0QzxYwa8LIbo5vzOBwVGqu+P5XEsVB61H/mmLi12N0bNCsIgY678p537kpUGGNwJct98K/uJF1tQd/Tr/4YicEQgbJxSDzO/FnyRWRPNuIOSQ9lDyivA4vGer3pq8T8o76lOv6+mO6AHXqn2iaEVXv4ixYlqujp0ZH1gNUiDj6JKHkWEeWjRXYrRUFIC55AGtJc3JMXUluhotBuzgFYtT6mVJM7cpJeXpPwLGv6Cxcv7qMkPqT2PQIDAQAB',
  googleMapsApiKey: 'AIzaSyAkFHUe2zOaG_kN1Jiamu4ZSoMEAYUJ20o',
  isPaymentFeatureEnabled: true,
  showDevOnlyComponent: false,
};
